import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const CoolingWaterTreatment: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-sanyola' title="Cooling Water Treatment – SANYOL® WT Series" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Cooling Water Treatment – SANYOL® WT Series</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Cooling water systems are vital for maintaining optimal operating temperatures in industrial processes. However, untreated cooling water can lead to scale formation, corrosion, biofouling, and reduced heat transfer efficiency. Our SANYOL® WT Cooling Water Treatment solutions provide comprehensive protection against these problems while optimizing system performance and extending equipment life.</p>
              <p>Our specialized cooling water chemicals are designed for open recirculating systems, closed loops, and once-through cooling applications across various industries.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Power plants and utility cooling systems</p>
              <p><i className="fa fa-oil-can text-primary me-2"></i>Petrochemical and refinery cooling towers</p>
              <p><i className="fa fa-cog text-primary me-2"></i>Manufacturing and process cooling systems</p>
              <p><i className="fa fa-building text-primary me-2"></i>HVAC and commercial cooling applications</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical and pharmaceutical cooling loops</p>

              <h3 className="mb-4">Product Range (SANYOL® WT)</h3>
              
              <h4 className="mb-3"><i className="fa fa-shield-alt text-primary me-2"></i>Scale & Corrosion Inhibitors:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Phosphonates, polymers, and zinc-based formulations</p>

              <h4 className="mb-3"><i className="fa fa-bug text-primary me-2"></i>Biocides & Microbiocides:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Oxidizing and non-oxidizing biocides for comprehensive biological control</p>

              <h4 className="mb-3"><i className="fa fa-layer-group text-primary me-2"></i>Dispersants:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Prevent deposit accumulation and improve heat transfer</p>

              <h4 className="mb-3"><i className="fa fa-balance-scale text-primary me-2"></i>pH Control Agents:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Maintain optimal pH for system protection</p>

              <h4 className="mb-3"><i className="fa fa-compress text-primary me-2"></i>Closed Loop Inhibitors:</h4>
              <p><i className="fa fa-circle text-secondary me-2"></i>Specialized treatments for glycol and non-glycol systems</p>

              <h3 className="mb-4">Features & Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Prevents scale formation and equipment fouling</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Controls corrosion and extends equipment life</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Eliminates bacterial and algae growth</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Improves heat transfer efficiency</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces water and energy consumption</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Complete water analysis and treatment program design</p>
              <p><i className="fa fa-star text-warning me-2"></i>Advanced monitoring and control systems</p>
              <p><i className="fa fa-star text-warning me-2"></i>24/7 technical support and emergency response</p>
              <p><i className="fa fa-star text-warning me-2"></i>Environmentally responsible formulations</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Proven performance in diverse cooling applications</p>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default CoolingWaterTreatment;
